import React from "react";

const ProductTag = ({ product }) => {
  if (!product) return null;

  let description = "";

  if (product.type === "discount") {
    if (product.discount?.type === "price") {
      description = `discount | $${product.price}`;
    } else if (product.discount?.type === "percentage") {
      description = `discount | ${product.percentage} % off`;
    }
  } else if (product.type === "voucher") {
    description = `voucher | $${product.price}`;
  } else if (product.type === "giftCard") {
    description = `giftcard | $${product.price}`;
  }

  return <span>{description}</span>;
};

export default ProductTag;
